export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11239.a557b9fe.jpg";